module.exports = __webpack_public_path__ + "prod/1.42.2/img/47.e0920a5a.svg";